import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=3fbf145f&scoped=true&"
import script from "./Alert.js?vue&type=script&lang=js&"
export * from "./Alert.js?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&id=3fbf145f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf145f",
  null
  
)

export default component.exports